#import "../fragments/user-quota-fragment.graphql"

mutation QuotaDelete($input: QuotaDeleteInput!) {
    quotaDelete(input: $input) {
        user {
            ...UserQuotaFragment
        }
    }
}
